import { connect } from 'react-redux';
import AttendanceDashboard from './AttendanceDashboard';
import { getAttendanceDashboardStatus } from './attendanceDashboardActions';

const mapStateToProps = state => ({
    isLoading: state.attendanceDashboard.isLoading,
    officeTypeStatus: state.attendanceDashboard.officeTypeStatus,
});

const mapDispatchToProps = dispatch => ({
    getAttendanceDashboardStatus: () => dispatch(getAttendanceDashboardStatus()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AttendanceDashboard);
